import { render, staticRenderFns } from "./product-settlement-sales-statistics.vue?vue&type=template&id=674aef58&scoped=true"
import script from "./product-settlement-sales-statistics.vue?vue&type=script&lang=js"
export * from "./product-settlement-sales-statistics.vue?vue&type=script&lang=js"
import style0 from "./product-settlement-sales-statistics.vue?vue&type=style&index=0&id=674aef58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674aef58",
  null
  
)

export default component.exports